import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.css.js';
const sizeStyles = {
  "xs": styles.sizeXS,
  "s": styles.sizeS,
  "m": styles.sizeM,
  "l": styles.sizeL
};
const Size = {
  "xs": "xs",
  "s": "s",
  "m": "m",
  "l": "l"
};
const LoadingIcon16 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 3.25a4.75 4.75 0 1 0 4.686 3.968.75.75 0 1 1 1.48-.245q.083.503.084 1.027a6.25 6.25 0 1 1-5.223-6.166.75.75 0 0 1-.245 1.48A5 5 0 0 0 8 3.25",
  style: {
    animation: "rs-icon-rotate 1s linear infinite",
    transformOrigin: "center center"
  }
})));
LoadingIcon16.displayName = 'LoadingIcon16';
const LoadingIcon20 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 4a6 6 0 1 0 5.92 5.012 1 1 0 0 1 1.972-.326Q18 9.329 18 10a8 8 0 1 1-6.686-7.892 1 1 0 0 1-.326 1.973A6 6 0 0 0 10 4",
  style: {
    animation: "rs-icon-rotate 1s linear infinite",
    transformOrigin: "center center"
  }
})));
LoadingIcon20.displayName = 'LoadingIcon20';
const LoadingIcon24 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6a6 6 0 1 0 5.92 5.012 1.5 1.5 0 0 1 2.959-.49q.12.724.121 1.478a9 9 0 1 1-7.522-8.879 1.5 1.5 0 0 1-.49 2.96Q12.508 6 12 6",
  style: {
    animation: "rs-icon-rotate 1s linear infinite",
    transformOrigin: "center center"
  }
})));
LoadingIcon24.displayName = 'LoadingIcon24';
const LoadingIcon28 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 6.5a7.5 7.5 0 1 0 7.399 6.265 1.5 1.5 0 0 1 2.96-.49q.14.844.141 1.725c0 5.799-4.701 10.5-10.5 10.5S3.5 19.799 3.5 14 8.201 3.5 14 3.5q.813 0 1.595.12a1.5 1.5 0 0 1-.453 2.966A7.6 7.6 0 0 0 14 6.5",
  style: {
    animation: "rs-icon-rotate 1s linear infinite",
    transformOrigin: "center center"
  }
})));
LoadingIcon28.displayName = 'LoadingIcon28';
const LoadingIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    theme,
    size: sizeFromProps = "m",
    className,
    style,
    ['data-render-all-sizes']: renderAllSizes = false,
    ...props
  } = _ref;
  const size = sizeFromProps in Size ? sizeFromProps : "m";
  const mainProps = { ...props,
    className: cn(styles.icon, styles[theme], sizeStyles[size], renderAllSizes && styles.allVariants, className),
    style: renderAllSizes ? {
      '--rs-icon-ar-width': 28,
      '--rs-icon-ar-height': 28,
      ...style
    } : style,
    ref
  };

  if (renderAllSizes) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 28 28"
    }, mainProps), /*#__PURE__*/React.createElement(LoadingIcon16, {
      className: styles.variant16
    }), /*#__PURE__*/React.createElement(LoadingIcon20, {
      className: styles.variant20
    }), /*#__PURE__*/React.createElement(LoadingIcon24, {
      className: styles.variant24
    }), /*#__PURE__*/React.createElement(LoadingIcon28, {
      className: styles.variant28
    }));
  }

  if (size === Size['xs']) {
    return /*#__PURE__*/React.createElement(LoadingIcon16, mainProps);
  }

  if (size === Size['s']) {
    return /*#__PURE__*/React.createElement(LoadingIcon20, mainProps);
  }

  if (size === Size['m']) {
    return /*#__PURE__*/React.createElement(LoadingIcon24, mainProps);
  }

  return /*#__PURE__*/React.createElement(LoadingIcon28, mainProps);
});
LoadingIcon.displayName = 'LoadingIcon';
LoadingIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"]),
  'data-render-all-sizes': PropTypes.bool,
  style: PropTypes.object
};
export { Size, LoadingIcon as default };
